import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CaptchaService } from 'services/captcha.service';

@Component({
	selector: 'ras-captcha',
	templateUrl: './captcha.component.html',
	styleUrls: ['./captcha.component.sass']
})
export class CaptchaComponent implements OnInit, AfterViewInit {

	timeout_delay = 4000
	site_key = '6LdETSYTAAAAAIg3PbQgYqdwxZ4p7DKiUZ0sVzeT'

	@ViewChild('captcha') captcha_element;
	public captcha_initialised = undefined
	public timeout = false
	@Output() success = new EventEmitter()

	constructor(private captchaService: CaptchaService, private ref: ChangeDetectorRef) { }

	ngOnInit() {
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.timeout = true
			this.ref.detectChanges()
		}, this.timeout_delay)
		// this.captchaService.on_ready(() => {
		// 	this.captcha_initialised = true
		// 	this.ref.detectChanges()
		// 	window["grecaptcha"].render(this.captcha_element.nativeElement, {
		// 		sitekey: this.site_key,
		// 		callback: response => {
		// 			this.success.emit()
		// 			this.ref.detectChanges()
		// 		}
		// 	})
		// })
		this.captchaService.on_ready(
			(site_key: string) => {
				// this.captcha_ready = true; console.log("CAPTCHA READY")
				window["grecaptcha"].execute(site_key, { action: 'submit' }).then(async token => {
					// token received successfully.
					this.captcha_initialised = true
					this.success.emit()
					this.ref.detectChanges()
				})
			}
		)
	}
}
